import {
  AfterViewInit,
  Component,
  Input,
  ViewChild
} from '@angular/core';
import {
  ControlContainer,
  NgForm,
  NgModel
} from '@angular/forms';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-unique-text-control',
  template: require('./unique-text-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class UniqueTextControlComponent extends TextControlComponent implements AfterViewInit {
  public isUnique = true;

  @Input() checkInitially = false;
  @Input() validate : ( value : string ) => Promise<boolean>;

  @ViewChild('input') ngModel : NgModel;

  ngAfterViewInit () : void {
    if (this.checkInitially && this._model && this.ngModel) {
      this.handleValidation();
    }
  }

  handleModelChange ( _model : string ) : void {
    this.modelChange.emit(_model);

    this.handleValidation();
  }

  handleValidation( _model = this._model ) : void {
    this.validate(_model)
    .then(( isUnique : boolean ) => {
      this.isUnique = isUnique;
    });
  }
}
